<template>
  <div style="display: flex; flex-flow: row">
    <swingcard :pose="loading">
      <el-card
        :body-style="{ padding: '0px' }"
        class="clickable"
        style="width: 13.5rem; height: 20rem;"
        @click.native="refreshCard()">
        <div style="padding: 2rem 1.5rem;">
          <div class="lead">{{ header }}...</div>
          <h2 class="hyphenate" style="font-size:1.3rem;">{{activeCard.name}}</h2>
          <div class="bottom clearfix">{{activeCard.desc}}</div>
          <div class="bottom pos-abs clearfix">
            <el-button class="el-icon-refresh clickable icon-small" @click="refreshCard()" round></el-button>
          </div>
        </div>
      </el-card>
    </swingcard>
    <div class="card-supplement">
      <div class="example">
        {{activeCard.example}}
      </div>
      <div class="counter">
        <progressRing :step="'3'" :currentStep="this.currentStep" :ringColor="'#ffffff'" :textColor="'#ffffff'" :showText="true" :min="0" :max="40" :value="0"></progressRing>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import posed from 'vue-pose'
import { interpolate } from '@popmotion/popcorn'
import progressRing from './loader.vue';

export default {
  template: ``,
  props: {
    header: {
      type: String,
      default: 'What if'
    },
    currentStep: {
      type: String,
      default: '1'
    }
  },
  components: {
    progressRing, swingcard: posed.div({
      draggable: 'x',
      dragBounds: { left: -200, right: 200 },
      passive: {
        rotate: ['x', interpolate(
          [-200, -100, 100, 200],
          ['-8deg', '-2deg', '2deg', '8deg']
        )],
        y: ['x', v => 0.25 * v * Math.sin(v * 0.01)]
      },
      dragEnd: {x:0, y:0},
      'true': {
        x: 0
      }
    })
  },
  data: function() {
    return {
      loading: 'false',
      deck: [],
      active: 0,
      activeCard: {}
    }
  },
  methods: {
    refreshCard() {
      let vm = this,
        l = _.size(vm.deck)

      vm.active += vm.active < l-1 ? 1 : -l
      vm.setActive(vm.active)
    },
    setActive(index) {
      this.activeCard = this.deck[index]
      this.$root.$emit('resetTimer', true, true)
    }
  },
  watch: {
    activeCard: function() {
      this.loading = 'true'
      setTimeout(() => this.loading = 'false', 150);
    }
  },
  mounted() {
    this.$root.$on('loadWhatif', (deck) => {
      this.deck = deck
      this.setActive(0)
    })
    this.$root.$on('skip', () => {
      this.refreshCard()
    })
  }
}
</script>

<style>
  .lead {
    font-weight: 700;
    font-size: .7rem;
  }

  .bottom {
    margin-top: 1rem;
    line-height: 1.3rem;
    font-size: .9rem;
    position: relative;
    text-align: left;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
    clear: both
  }

  .el-card {
    border-radius: 1rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
  }

  .el-card h2, .el-card span {
    position: relative;
    z-index: 1;
  }

  .el-card .image {
    width: 100%;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    z-index: 0;
  }

  .leader {
    margin: 2rem 1rem;
  }

  .card-supplement {
    display: flex; 
    flex-flow: column;
    align-items: flex-start;
    margin-top: 1rem;
    margin-left: 2rem;
    margin-right: 5rem;
  }

  .example {
    line-height: 1.5rem;
    font-weight: 500;
    color: #303133;
    font-size: 0.9rem;
    margin-top: 3rem;
  }

  #step3 .counter {
    margin-top: 1rem;
    position: relative;
    bottom: 0;
    right: 0;
  }
</style>
